// すべてのページで実行するスクリプト
console.log('姫路みたい スクリプトが実行された.');

$('body').removeClass('no-js');

// Bootstrap画面横幅を検出する為
// https://github.com/maciej-gurban/responsive-bootstrap-toolkit#basic-usage
var visibilityDivs = {
  'xs': $('<div class="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none"></div>'),
  'sm': $('<div class="d-none d-sm-block d-md-none d-lg-none d-xl-none"></div>'),
  'md': $('<div class="d-none d-md-block d-sm-none d-lg-none d-xl-none"></div>'),
  'lg': $('<div class="d-none d-lg-block d-sm-none d-md-none d-xl-none"></div>'),
  'xl': $('<div class="d-none d-xl-block d-sm-none d-md-none d-lg-none"></div>'),
};

// IE以外のブラウザーにスクロールアニメーションを実行する
var ieUser = navigator.userAgent.match(/MSIE \d|Trident.*rv:/);
var edgeUser = navigator.userAgent.match(/Edge/);
var safariUser = navigator.userAgent.match(/Safari/);
var touchUser = navigator.userAgent.match(/(iPhone|iPad|Android|iPod)/);

if (ieUser) {
  // IEのobject-fitが対応できるようになるため
  objectFitImages();
} else {
  AOS.init({
    offset: 120,
    easing: 'ease-in-out-back',
    once: true
  });
}

// MD, LGサイズで一件を非表示する
(function($, viewport) {
  $(document).ready(function() {
    viewport.use('custom', visibilityDivs);

    // Bootstrapサイズをbodyにクラスめいをつける
    $(window).resize(
      viewport.changed(function() {
        $('body').removeClass(function(index, className) {
          return (className.match (/(^|\s)bs-\S+/g) || []).join(' ');
        });
        $('body').addClass('bs-' + viewport.current());
      })
    ).resize();

    $(window).on('load', function() {

      // デスクトップ + トップページ + IE以外の条件で。。。
      if (viewport.is('>=md') && $('body').hasClass('home') && !ieUser && !edgeUser) {

        // 12件の記事を表示するように(HTMLに入っている４件＋AJAXを２回実行する))
        $cardOriginals.each(function(index, item) {
          loadHiddenItems(null, '.append[data-tag="' + $(item).data('tag') + '"] .append__load-button')
            .then(function() {
              loadHiddenItems(null, '.append[data-tag="' + $(item).data('tag') + '"] .append__load-button')
            });
        }); // $.each

        // デスクトップ版のタブメニューの固定設定を更新する
        tabbySticky.props.stickyBitStickyOffset = $('.tab-table').height();
        tabbySticky.update();

        tabMenuSticky.props.stickyBitStickyOffset = 0;
        tabMenuSticky.update();
      }
    })
  });
})(jQuery, ResponsiveBootstrapToolkit);

//ページ内リンクへスクロールする
$("a[href*='#']"+'a:not(".nav-link")').smoothScroll({
  offset: $('.global-menu__upper').height() * -1.2
});

/**
   * ２つの日付の間を計算する関数
   *
   * @param {string} date1 - JSのDateオブジェクト
   * @param {string} date2 - JSのDateオブジェクト
   * @return {number} 日付の間の整数
   *
   * @example
   *    numDaysBetween( new Date('2018-10-10'), new Date('2018-10-31') )
   */
  var numDaysBetween = function(date1, date2) {
    var diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  };
